/**
 * Wochentage, ISO-Zählung (1 = Montag … 7 = Sonntag).
 *
 * Eine Quelle statt der bisherigen zwei leicht abweichenden Kopien
 * (`CalendarPage.tsx` zählte Sonntag als 0, `SettingsPage.tsx` als 7) – beide
 * mussten dieselbe Frage beantworten und taten es unterschiedlich.
 */
export const WEEKDAYS = [
  { number: 1, short: 'Mo', label: 'Montag' },
  { number: 2, short: 'Di', label: 'Dienstag' },
  { number: 3, short: 'Mi', label: 'Mittwoch' },
  { number: 4, short: 'Do', label: 'Donnerstag' },
  { number: 5, short: 'Fr', label: 'Freitag' },
  { number: 6, short: 'Sa', label: 'Samstag' },
  { number: 7, short: 'So', label: 'Sonntag' },
] as const;
